import _Object$assign from 'babel-runtime/core-js/object/assign';

import { PlanType, GrantType } from '@/common/permission';

export default {
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  watch: {
    'formValue.type': function formValueType(type) {
      _Object$assign(this.formValue, {
        plan_id: '',
        channel_ids: [],
        disabledChannel: false,
        is_all_channel: true,
        change_keys: [],
        image: '',
        credit: {
          min_amount: 0,
          support_credit: 1,
          approval_url: ''
        }
      });
    },
    'formValue.adv_id': function formValueAdv_id(val) {
      if (val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.type = PlanType.Subscription;
      }
    }
  },
  data: function data() {
    return {
      planList: [],
      options: [{
        label: '订阅套餐',
        value: PlanType.Subscription
      }, {
        label: '按量套餐',
        value: PlanType.Ration
      }, {
        label: '充值消耗套餐',
        value: PlanType.Recharge
      }]
    };
  },

  computed: {},
  methods: {
    handleSelect: function handleSelect(id) {},
    checkDisabled: function checkDisabled(type) {
      return this.action === 'update' || this.formValue.grant_type !== GrantType.Normal;
    }
  }
};